import React, { useEffect } from "react";
import "./home.scss";
import BusinessAssurance from "./sections/businessAssurance";
import Confront from "./sections/confront";
import WhoWeAre from "./sections/whoWeAre";
import HyaiaGathers from "./sections/hyaiaGathers";
import ForWhom from "./sections/forWhom";
import SlideCompanies from "./sections/slideCompanies";
import Differential from "./sections/differential";
import HowItWorks from "./sections/howItWorks";
import StepOne from "./sections/stepOne";
import StepTwo from "./sections/stepTwo";
import StepThree from "./sections/stepThree";
import StepFour from "./sections/stepFour";
import LetsStart from "./sections/letsStart";
import Aos from "aos";
import "aos/dist/aos.css";
import CustomerTestimonialsHome from "./sections/customerTestimonialsHome";

const Home = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div className="container-home">
      <div className="section-confront">
        <Confront />
      </div>
      <div className="section-business-assurance">
        <BusinessAssurance />
      </div>
      <div className="section-who-we-are">
        <WhoWeAre />
      </div>
      <div className="section-hyaia-gathers">
        <HyaiaGathers />
      </div>
      <div className="section-slide-companies">
        <SlideCompanies />
      </div>
      <div className="section-for-whom">
        <ForWhom />
      </div>
      <div className="section-differential">
        <Differential />
      </div>
      <div className="section-how-it-works">
        <HowItWorks />
      </div>
      <div className="section-step-one">
        <StepOne />
      </div>
      <div className="section-step-two">
        <StepTwo />
      </div>
      <div className="section-step-three">
        <StepThree />
      </div>
      <div className="section-step-four">
        <StepFour />
      </div>
      <div className="section-custumer-testimonials-home">
        
      </div>
      <div className="section-lets-start">
        <LetsStart />
      </div>
    </div>
  );
};
export default Home;
